import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class RedirectRecord
 * @augments BaseMessageRecord
 */
class RedirectRecord extends BaseMessageRecord({
  type: "redirect_block",

  /**
   * @memberof RedirectRecord#
   */
  responseId: ""
}) {}

/**
 * Validation
 */

/**
 * @param {RedirectRecord} message
 * @returns {Immutable.List.<String>}
 */
RedirectRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.responseId) {
    invalidFields.add("responseId");
  }

  return Immutable.List(invalidFields);
};

export default RedirectRecord;
